import type { SupplierWorkforce } from '@tandemone/types'
import { createContext } from 'react'

export type WorkforceFieldKey = keyof SupplierWorkforce

/**
 * values held as strings so empty + partial-typing states are representable.
 * coerce to int on submit.
 */
export type WorkforceFormState = Record<WorkforceFieldKey, string> & {
  submitError: string | null
}

export type WorkforceFormAction =
  | { type: 'setField'; field: WorkforceFieldKey; value: string }
  | { type: 'submitError'; message: string | null }

export type WorkforceDerived = {
  totalMissing: boolean
  isValid: boolean
}

export type WorkforceFormContextValue = {
  state: WorkforceFormState
  derived: WorkforceDerived
  dispatch: React.Dispatch<WorkforceFormAction>
  isSubmitting: boolean
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

export const WorkforceFormContext =
  createContext<WorkforceFormContextValue | null>(null)
